import { styled } from '@mui/material';

export const StyledProcessingAudio = styled('div')`
  width: 600px;
  max-width: 100%;
  margin: auto;
  gap: 16px;
  .processing-audio-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
